"use strict";
// https://github.com/ordinals/ord/blob/master/src/media.rs
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = void 0;
exports.ContentType = {
    APPLICATION_BSV20: 'application/bsv-20',
    BSV20: 'application/bsv-20',
    APPLICATION_CBOR: 'application/cbor',
    CBOR: 'application/cbor',
    APPLICATION_JSON: 'application/json',
    JSON: 'application/json',
    APPLICATION_PDF: 'application/pdf',
    PDF: 'application/pdf',
    APPLICATION_PGP_SIGNATURE: 'application/pgp-signature',
    PGP_SIGNATURE: 'application/pgp-signature',
    APPLICATION_PROTOBUF: 'application/protobuf',
    PROTOBUF: 'application/protobuf',
    APPLICATION_YAML: 'application/yaml',
    YAML: 'application/yaml',
    AUDIO_FLAC: 'audio/flac',
    FLAC: 'audio/flac',
    AUDIO_MPEG: 'audio/mpeg',
    MPEG: 'audio/mpeg',
    AUDIO_WAV: 'audio/wav',
    WAV: 'audio/wav',
    FONT_OTF: 'font/otf',
    OTF: 'font/otf',
    FONT_TTF: 'font/ttf',
    TTF: 'font/ttf',
    FONT_WOFF: 'font/woff',
    WOFF: 'font/woff',
    FONT_WOFF2: 'font/woff2',
    WOFF2: 'font/woff2',
    IMAGE_APNG: 'image/apng',
    APNG: 'image/apng',
    IMAGE_AVIF: 'image/avif',
    AVIF: 'image/avif',
    IMAGE_GIF: 'image/gif',
    GIF: 'image/gif',
    IMAGE_JPEG: 'image/jpeg',
    JPEG: 'image/jpeg',
    JPG: 'image/jpeg',
    IMAGE_PNG: 'image/png',
    PNG: 'image/png',
    IMAGE_SVG_XML: 'image/svg+xml',
    SVG_XML: 'image/svg+xml',
    IMAGE_WEBP: 'image/webp',
    WEBP: 'image/webp',
    MODEL_GLTF_JSON: 'model/gltf+json',
    GLTF_JSON: 'model/gltf+json',
    MODEL_GLTF_BINARY: 'model/gltf-binary',
    GLTF_BINARY: 'model/gltf-binary',
    MODEL_STL: 'model/stl',
    STL: 'model/stl',
    TEXT: 'text/plain',
    TEXT_UTF8: 'text/plain;charset=utf-8',
    TEXT_CSS: 'text/css',
    CSS: 'text/css',
    TEXT_HTML: 'text/html',
    HTML: 'text/html',
    TEXT_HTML_UTF8: 'text/html;charset=utf-8',
    TEXT_JAVASCRIPT: 'text/javascript',
    JAVASCRIPT: 'text/javascript',
    TEXT_MARKDOWN: 'text/markdown',
    MARKDOWN: 'text/markdown',
    TEXT_MARKDOWN_UTF8: 'text/markdown;charset=utf-8',
    VIDEO_MP4: 'video/mp4',
    MP4: 'video/mp4',
    VIDEO_WEBM: 'video/webm',
    WEBM: 'video/webm',
};
